import React from 'react';
import { ErrorState as BaseErrorState } from '../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { cardAnimationVariants } from '../BeFi20.meta';
import { Wrapper } from '../BeFi20.styles';
import { Main } from '../Survey/components/LoadingScreen/LoadingScreen.styles';

interface Props {
  isMobile?: boolean;
  message?: string;
  onAction?(): void;
}

export const ErrorState = ({ isMobile, message, onAction }: Props) => (
  <Wrapper justifyContent="center">
    <Main
      variants={cardAnimationVariants}
      initial="enter"
      animate="visible"
      mt={isMobile ? '24' : '32'}
    >
      <BaseErrorState message={message} onAction={onAction} />
    </Main>
  </Wrapper>
);
